export default "__VITE_ASSET__CbjinrJm__"